import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import AccommodationDetailPage from "./pages/AccommodationDetailPage";
import GalleryPage from "./pages/GalleryPage";
import SpaPage from "./pages/SpaPage";
import RegulaminPage from "./pages/RegulaminPage";
import NotFoundPage from "./pages/NotFoundPage";
import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-sand">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/accommodation/:id" element={<AccommodationDetailPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/spa" element={<SpaPage />} />
            <Route path="/regulamin" element={<RegulaminPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
